import { Component, OnInit } from '@angular/core';
import { Router }            from '@angular/router';

// import { Hero }                from './hero';
import { ApplicationContextService }         from './app-context.service';
import { ColorMode }         from './app-context.service';
@Component({
  //   moduleId: module.id,
  selector: 'about',
  templateUrl: './about.component.html',
  styleUrls:  ['./content.component.css','./about.component.css']
})
export class AboutComponent implements OnInit {

  constructor(
    private appContextService: ApplicationContextService,
    private router: Router) { }

  ngOnInit(): void {
    this.appContextService.SetMode(ColorMode.Black);

  }


}


/*
Copyright 2016 Google Inc. All Rights Reserved.
Use of this source code is governed by an MIT-style license that
can be found in the LICENSE file at http://angular.io/license
*/
